export default __webpack_public_path__ + "static/media/Linero3Closed.baae356e.png";